import React, { useState } from 'react'
import { Group, Paper, Button, PasswordInput, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';

interface FormData {
  email: string
  password: string
}

interface Props {
  onSubmit: (values: FormData) => Promise<void> | void
}

const LoginForm = ({ onSubmit }: Props) => {
  const [loading, setLoading] = useState(false);

  const mailAddressValidate = (value: string) => {
    if (!value) {
      return '必須です'
    }
    const regexp =
      /^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
    if (regexp.test(value)) {
      return undefined
    } else {
      return '正しいメールアドレスを入力してください'
    }
  }

  const passwordValidate = (value: string) => {
    if (!value) {
      return '必須です'
    }
    if (value.length > 16) {
      return '16文字以下で入力してください'
    }
    if (value.length < 8) {
      return '8文字以上で入力してください'
    }
    return undefined
  }

  const form = useForm({
    validateInputOnBlur: true,
    initialValues: {
      email: '',
      password: '',
    },
    validate: {
      email: mailAddressValidate,
      password: passwordValidate,
    },
  });


  return (
    <Paper shadow='xs' radius="lg" p={32} w={360}>
      <form onSubmit={form.onSubmit(async (values) => {
          setLoading(true);
          try {
            await onSubmit(values);
          } finally {
            setLoading(false);
          }
        })}>
        <Group
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px"
          }}
        >
          <TextInput
            label="メールアドレス"
            {...form.getInputProps('email')}
            mt={8}
            style={{ width: "100%" }}
            name='email'
            labelProps={{ mb: 8 }}
          />

          <PasswordInput
            label="パスワード"
            {...form.getInputProps('password')}
            mt={8}
            style={{ width: "100%" }}
            name='password'
            labelProps={{ mb: 8 }}
          />

          <Button
            variant="filled"
            radius="xl"
            w={120}
            mt={16}
            type="submit"
            disabled={!form.isValid() || loading}
          >
            {loading ? '処理中' : 'ログイン'}
          </Button>
        </Group>
      </form>
    </Paper>
  )
}

export default LoginForm
